module.exports = __webpack_public_path__ + "static/media/2-Kruzifixus-Erp-klein.9ac18476.jpg";